<template>
  <button class="btn btn-cta comment-cta" @click.prevent="trigger()">
    <svg viewBox="0 0 512 512">
      <use href="#pen-paper" />
    </svg>
    <span v-text="text" />
  </button>
</template>

<script>
import { mapActions } from 'vuex';
import { FORM_INITIAL } from '../../createCommentStepsHelper';

export default {
  name: 'CreateCommentCta',

  data() {
    return {
      text: lavendlaObituary.common.writeCondolenceShort,
    };
  },

  methods: {
    ...mapActions('createComment', ['toggleModal']),

    trigger() {
      this.toggleModal(FORM_INITIAL);
    },
  },
};
</script>
